import mobile_nav_button_init from "./mobile_toggle_button";
import {navigation_links_init} from "./navigation_links"
import footer_navigation_init from "./footer_navigation";


const global_navigation_init = () => {
    mobile_nav_button_init();
    navigation_links_init();
    footer_navigation_init();
}


export default global_navigation_init;